var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2383_1736)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9988 25.0199C43.9859 33.2744 37.2627 39.993 29.0082 40C20.7338 40.0059 13.986 33.2545 14 24.9801C14.0129 16.7244 20.7361 10.0059 28.9906 10C37.2639 9.9918 44.0117 16.7455 43.9988 25.0199Z",
    fill: "#3D5B9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8158 16.1067V19.0017C33.7574 19.0017 33.6929 19.0002 33.63 19.0017C33.0022 19.0119 32.3729 19.009 31.7466 19.0339C30.9421 19.0677 30.5015 19.4739 30.4671 20.26C30.4341 21.0387 30.4596 21.8204 30.4596 22.6241H33.7184C33.5731 23.7196 33.4322 24.7873 33.2899 25.8725H30.4671C30.4611 25.937 30.4551 25.9825 30.4551 26.028V34.0648C30.4551 34.0956 30.4581 34.1249 30.4596 34.1542H27.0524C27.0465 34.078 27.0375 34.0017 27.0375 33.9254C27.036 31.3237 27.036 28.7206 27.036 26.1189V25.874H24.2012V22.6314H27.036V22.3997C27.042 21.5476 27.0195 20.6955 27.0614 19.8449C27.1154 18.6951 27.5019 17.6715 28.4264 16.9015C29.0527 16.3794 29.7943 16.1111 30.6019 16.0275C31.5624 15.9292 32.5198 16.0025 33.4772 16.0817C33.5851 16.0905 33.6929 16.0979 33.8158 16.1067Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2383_1736",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2383_1736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2383_1736",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-Icon.0c30cb07481efec1c8050b4e0354a8a1.svg";
export { ForwardRef as ReactComponent };